import React, { useEffect, useRef, useState } from "react";
import { ProductsApi } from "apis/ProductsApi";
import { BrandsApi } from "apis/BrandsApi";
import { toast } from "react-toastify";
import DeleteIcon from "@mui/icons-material/Delete";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Unstable_Grid2";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import TextField from "@mui/material/TextField";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import DialogActions from "@mui/material/DialogActions";
import Autocomplete from "@mui/material/Autocomplete";
import { StatesApi } from "apis/StatesApi";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import AddPriceTable from "components/Tables/AddPriceTable";
import { useNavigate } from "react-router";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormLabel from "@mui/material/FormLabel";
import TableHeader from "components/Table/TableHeader";
import TableElement from "components/Table/TableElement";
import { styled } from "@mui/material/styles";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { filterInputSx, filterSelectSx, filterFormControlSx } from "utils/ui";
import { createSvgIcon, useMediaQuery } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useDispatch, useSelector } from "react-redux";
import CircularIndeterminateModal from "../../utils/Loading";
import { setLoadingPanel } from "../../redux/features/loading";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const LastDayOfMonth = (y, m) => {
  return new Date(y, m, 0).getDate();
};
export default function Products() {
  const navigate = useNavigate();
  const date = new Date();
  // const day = date.getDay();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  const [totalPages, setTotalPages] = useState();
  const [totalElements, setTotalElements] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [fetchSize, setFetchSize] = useState(25);
  const [isActive, setIsActive] = useState(null);

  const periodFrom = `${year}-${month > 9 ? month : "0" + month}-01`;
  const periodTo = `${year}-${month > 9 ? month : "0" + month}-${LastDayOfMonth(
    year,
    month
  )}`;

  const color = "light";
  const [brands, setBrands] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedPricesForEdit, setSelectedPricesForEdit] = useState([]);

  const [productData, setProductData] = useState();
  const [open, setOpen] = useState(false);
  const [AddData, setAddData] = useState(false);
  const [productAddPayload, setProductAddPayload] = useState({
    primaryName: null,
    productCode:null,
    secondaryName: null,
    specifications: {},
    image: null,
    video: null,
    description: null,
    brand: null,
    category: null,
    hsnCode: null,
    tacCode: [],
    categoryId: null,
    subCategory: null,
    subCategoryId: null,
    variants: [],
    brandId: null,
    brandSeriesId: null,
    brandSeries: null,
    isVerified: true,
    isActive: true,
    position: 0,
  });
  const [isEdit, setIsEdit] = useState(false);
  const [isVariantOpen, setIsVariantOpen] = useState(false);
  const [isColorOpen, setIsColorOpen] = useState(false);
  const [isPriceOpen, setIsPriceOpen] = useState(false);
  const [isPriceTableOpen, setIsPriceTableOpen] = useState(false);
  const [variantPayload, setVariantPayload] = useState({
    variantType: "",
    value: "",
  });
  const [colorPayload, setColorPayload] = useState({
    id: "",
    name: "",
    hexCode: "",
  });
  const [pricePayload, setPricePayload] = useState({
    mrp: "",
    mop: "",
    dp: "",
    nlc: null,
    remark: "",
    startDate: periodFrom,
    endDate: periodTo,
    groups: [""],
    isActive: true,
  });
  const [specification, setSpecification] = useState({
    key: null,
    value: null,
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const searchDebounceRef = useRef(null);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [isEditingColor, setIsEditingColor] = useState(false);
  const [isEditingVariant, setIsEditingVariant] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [states, setStates] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [columns, setColumns] = useState([]);
  let priceArray = [];
  const [renderPrice, setRenderPrice] = useState([]);
  const [selectedPrice, setSelectedPrice] = useState("");
  const [editIndividualPrice, setEditIndividualPrice] = useState(false);
  const [singleEditPayload, setSingleEditPayload] = useState({
    startDate: "",
    endDate: "",
    mop: "",
    dp: "",
    mrp: "",
    remark: "",
  });

  const [isSavingPrice, setIsSavingPrice] = useState(false);

  const [productRow, setProductRow] = useState(null);

  const basicSpecs = {
    IMAGE: "",
    VIDEO: "",
    DETAILS: "",
    PROCESSOR: "",
    FRONT_CAMERA: "",
    BACK_CAMERA: "",
    RAM: "",
    STORAGE: "",
    DISPLAY: "",
    BATTERY: "",
  };
  const openAddUpdateProduct = () => {
    setIsEdit(false);
    setSpecification({});
    setProductAddPayload({
      primaryName: null,
      productCode:null,
      specifications: basicSpecs,
      secondaryName: null,
      image: null,
      video: null,
      description: null,
      brand: null,
      category: null,
      hsnCode: null,
      tacCode: [],
      categoryId: null,
      subCategory: null,
      subCategoryId: null,
      variants: [],
      brandId: null,
      brandSeriesId: null,
      brandSeries: null,
      isVerified: true,
      isActive: true,
      position: 0,
    });
    setOpen(true);
  };

  const [openPricesTable, setOpenPricesTable] = useState(false);
  const [productPrices, setProductPrices] = useState(null);
  const handleClickOpenPrices = (prices) => {
    setProductPrices(prices);
    setOpenPricesTable(true);
  };
  const [isloading, setIsLoading] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const handleClosePrices = () => {
    setOpenPricesTable(false);
    setProductPrices([]);
  };
  const fetchData = async () => {
    try {
      setIsLoading(true);
      await Promise.all([getBrands(), getCategories(), getStates()]);
    } catch (error) {
      toast(error.response?.status + " " + error?.response?.data?.message, {
        type: "error",
        position: toast.POSITION.TOP_CENTER,
        autoClose: 1000,
      });
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    getProducts(
      selectedBrand?.id,
      currentPage - 1,
      fetchSize,
      debouncedSearchTerm,
      isActive
    );
  }, [currentPage, selectedBrand, fetchSize, debouncedSearchTerm, isActive]);

  const getCategories = () => {
    ProductsApi.GetCategoryList({
      page: 0,
      size: 99,
    })
      .then((res) => {
        setCategoryList(res.data.data.filter((d) => d.isActive));
      })
      .catch((err) => {
        if (err?.response?.data) {
          toast(err.response?.status + " " + err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        } else {
          toast(err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        }
        if (err.response?.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      });
  };

  const getBrands = () => {
    dispatch(setLoadingPanel(true));
    BrandsApi.GetBrandsListByFilter({
      page: 0,
      size: 99,
    })
      .then((res) => {
        const filteredBrands = res.data.data.filter((d) => d.isActive);
        setBrands(filteredBrands);
        setSelectedBrand(filteredBrands[0]);
        dispatch(setLoadingPanel(false));
      })
      .catch((err) => {
        dispatch(setLoadingPanel(false));
        if (err?.response?.data) {
          toast(err.response?.status + " " + err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        } else {
          toast(err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        }
        if (err.response?.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      });
  };

  const getProducts = (brandId, page, size, searchTerm, isActive) => {
    dispatch(setLoadingPanel(true));
    if (searchTerm !== undefined && searchTerm !== "") {
      ProductsApi.SearchProducts({
        page: page,
        size: size,
        keyword: searchTerm,
        brandId: brandId,
        isActive: isActive,
      })
        .then((res) => {
          setProducts(res.data.data);
          setTotalPages(res.data.pages);
          setTotalElements(res.data.totalElements);
          dispatch(setLoadingPanel(false));
          setIsSearchLoading(false);
        })
        .catch((err) => {
          dispatch(setLoadingPanel(false));
          setIsSearchLoading(false);
          toast(err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        });
    } else {
      ProductsApi.GetProductsListByFilter({
        page: page,
        size: size,
        brandId: brandId,
        isActive: isActive,
      })
        .then((res) => {
          setProducts(res.data.data);
          setTotalPages(res.data.pages);
          setTotalElements(res.data.totalElements);
          dispatch(setLoadingPanel(false));
          setIsSearchLoading(false);
        })
        .catch((err) => {
          dispatch(setLoadingPanel(false));
          setIsSearchLoading(false);
          if (err?.response?.data) {
            toast(err.response?.status + " " + err?.response?.data?.message, {
              type: "error",
              position: toast.POSITION.TOP_CENTER,
              autoClose: 1000,
            });
          } else {
            toast(err?.response?.data?.message, {
              type: "error",
              position: toast.POSITION.TOP_CENTER,
              autoClose: 1000,
            });
          }
          if (err.response?.status === 401) {
            localStorage.clear();
            navigate("/");
          }
        });
    }
  };

  const handleChange = (event) => {
    setCurrentPage(1);
    setSearchTerm("");
    setDebouncedSearchTerm("");
    setSelectedBrand(event.target.value);
  };

  const save = () => {
    ProductsApi.AddProduct(productAddPayload)
      .then((res) => {
        toast("Product Created", {
          type: "success",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        setOpen(false);
        setProductData(res.data);
        setCurrentPage(1);
        fetchData();
      })
      .catch((err) => {
        if (err?.response?.data) {
          toast(err.response?.status + " " + err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        } else {
          toast(err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        }
        if (err.response?.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      });
  };

  const editProduct = (row) => {
    setIsEdit(true);
    setProductAddPayload({
      id: row.id,
      productCode: row.productCode,
      primaryName: row.primaryName,
      secondaryName: row.secondaryName,
      image: row.image,
      video: row.video,
      description: row.description,
      hsnCode: row.hsnCode,
      tacCode: row.tacCode?.length > 0 ? row.tacCode : undefined,
      categoryId: row.category.id,
      subCategoryId: row.subCategory.id,
      variants: row.variants,
      brandId: row.brand.id,
      brandSeriesId: row.brandSeries.id,
      isVerified: true,
      specifications:
        row.specifications && Object.keys(row.specifications).length !== 0
          ? row.specifications
          : basicSpecs,
      isActive: row.isActive,
      position: row.position,
    });
    setOpen(true);
  };

  const edit = () => {
    ProductsApi.EditProduct(productAddPayload.id, productAddPayload)
      .then(() => {
        toast("Product Updated", {
          type: "success",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            maxWidth: "90vw",
            width: "auto",
            margin: "5px  auto",
            padding: "5px 5px",
            fontSize: "14px",
          },
          closeButton: (
            <div className="flex justify-end">
              <button className="text-gray-500 hover:text-gray-800 focus:outline">
                <CloseIcon className="w-7 h-7" />
              </button>
            </div>
          ),
        });
        setOpen(false);
        getProducts(selectedBrand?.id, currentPage - 1, fetchSize, searchTerm);
      })
      .catch((err) => {
        if (err?.response?.data) {
          toast(err.response?.status + " " + err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: {
              maxWidth: "90vw",
              width: "auto",
              margin: "5px  auto",
              padding: "5px 5px",
              fontSize: "14px",
            },
            closeButton: (
              <div className="flex justify-end">
                <button className="text-gray-500 hover:text-gray-800 focus:outline">
                  <CloseIcon className="w-7 h-7" />
                </button>
              </div>
            ),
          });
        } else {
          toast(err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: {
              maxWidth: "90vw",
              width: "auto",
              margin: "5px  auto",
              padding: "5px 5px",
              fontSize: "14px",
            },
            closeButton: (
              <div className="flex justify-end">
                <button className="text-gray-500 hover:text-gray-800 focus:outline">
                  <CloseIcon className="w-7 h-7" />
                </button>
              </div>
            ),
          });
        }
        if (err.response?.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      });
  };

  const addEditVariant = (row) => {
    setSelectedProduct(row);
    setIsVariantOpen(true);
  };
  const addEditColor = (row) => {
    setSelectedProduct(row);
    setIsColorOpen(true);
  };

  const saveVariant = () => {
    ProductsApi.AddVariant(productData.data.data.id, variantPayload)
      .then(() => {
        toast("Success", { type: "success" });
        setIsVariantOpen(false);
        getProducts(null, 0);
      })
      .catch((err) => {
        if (err?.response?.data) {
          toast(err.response?.status + " " + err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: {
              maxWidth: "90vw",
              width: "auto",
              margin: "5px  auto",
              padding: "5px 5px",
              fontSize: "14px",
            },
            closeButton: (
              <div className="flex justify-end">
                <button className="text-gray-500 hover:text-gray-800 focus:outline">
                  <CloseIcon className="w-7 h-7" />
                </button>
              </div>
            ),
          });
        } else {
          toast(err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: {
              maxWidth: "90vw",
              width: "auto",
              margin: "5px  auto",
              padding: "5px 5px",
              fontSize: "14px",
            },
            closeButton: (
              <div className="flex justify-end">
                <button className="text-gray-500 hover:text-gray-800 focus:outline">
                  <CloseIcon className="w-7 h-7" />
                </button>
              </div>
            ),
          });
        }
        if (err.response?.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      });
  };
  const saveColor = () => {
    ProductsApi.AddColor(productData.data.data.id, colorPayload)
      .then(() => {
        toast("Success", {
          type: "success",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            maxWidth: "90vw",
            width: "auto",
            margin: "5px  auto",
            padding: "5px 5px",
            fontSize: "14px",
          },
          closeButton: (
            <div className="flex justify-end">
              <button className="text-gray-500 hover:text-gray-800 focus:outline">
                <CloseIcon className="w-7 h-7" />
              </button>
            </div>
          ),
        });
        setIsColorOpen(false);
        getProducts(null, 0);
      })
      .catch((err) => {
        if (err?.response?.data) {
          toast(err.response?.status + " " + err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: {
              maxWidth: "90vw",
              width: "auto",
              margin: "5px  auto",
              padding: "5px 5px",
              fontSize: "14px",
            },
            closeButton: (
              <div className="flex justify-end">
                <button className="text-gray-500 hover:text-gray-800 focus:outline">
                  <CloseIcon className="w-7 h-7" />
                </button>
              </div>
            ),
          });
        } else {
          toast(err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: {
              maxWidth: "90vw",
              width: "auto",
              margin: "5px  auto",
              padding: "5px 5px",
              fontSize: "14px",
            },
            closeButton: (
              <div className="flex justify-end">
                <button className="text-gray-500 hover:text-gray-800 focus:outline">
                  <CloseIcon className="w-7 h-7" />
                </button>
              </div>
            ),
          });
        }
        if (err.response?.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      });
  };
  const editColorClicked = (row, product) => {
    setSelectedProduct(product);
    setColorPayload({
      name: row.name,
      hexCode: row.hexCode,
      id: row.id,
    });
    setIsEditingColor(true);
    setIsColorOpen(true);
  };
  const editVariantClicked = (row, product) => {
    setSelectedProduct(product);
    setVariantPayload({
      variantType: row.variantType,
      value: row.value,
      id: row.id,
    });
    setIsEditingVariant(true);
    setIsVariantOpen(true);
  };

  const editColor = () => {
    ProductsApi.EditColor(selectedProduct.id, colorPayload.id, colorPayload)
      .then(() => {
        toast("Success", {
          type: "success",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            maxWidth: "90vw",
            width: "auto",
            margin: "5px  auto",
            padding: "5px 5px",
            fontSize: "14px",
          },
          closeButton: (
            <div className="flex justify-end">
              <button className="text-gray-500 hover:text-gray-800 focus:outline">
                <CloseIcon className="w-7 h-7" />
              </button>
            </div>
          ),
        });
        setIsColorOpen(false);
        setIsEditingColor(false);
        getProducts(null, 0);
      })
      .catch((err) => {
        toast(err?.response?.data?.message, {
          type: "error",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            maxWidth: "90vw",
            width: "auto",
            margin: "5px  auto",
            padding: "5px 5px",
            fontSize: "14px",
          },
          closeButton: (
            <div className="flex justify-end">
              <button className="text-gray-500 hover:text-gray-800 focus:outline">
                <CloseIcon className="w-7 h-7" />
              </button>
            </div>
          ),
        });
      });
  };
  const editVariant = () => {
    ProductsApi.EditVariant(
      selectedProduct.id,
      variantPayload.id,
      variantPayload
    )
      .then(() => {
        toast("Success", {
          type: "success",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            maxWidth: "90vw",
            width: "auto",
            margin: "5px  auto",
            padding: "5px 5px",
            fontSize: "14px",
          },
          closeButton: (
            <div className="flex justify-end">
              <button className="text-gray-500 hover:text-gray-800 focus:outline">
                <CloseIcon className="w-7 h-7" />
              </button>
            </div>
          ),
        });
        setIsVariantOpen(false);
        setIsEditingVariant(false);
        getProducts(null, 0);
      })
      .catch((err) => {
        toast(err?.response?.data?.message, {
          type: "error",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            maxWidth: "90vw",
            width: "auto",
            margin: "5px  auto",
            padding: "5px 5px",
            fontSize: "14px",
          },
          closeButton: (
            <div className="flex justify-end">
              <button className="text-gray-500 hover:text-gray-800 focus:outline">
                <CloseIcon className="w-7 h-7" />
              </button>
            </div>
          ),
        });
      });
  };

  //? new add price
  const getStates = () => {
    dispatch(setLoadingPanel(true));
    StatesApi.GetStatesListByFilter()
      .then((res) => {
        setStates(res.data.data);
        dispatch(setLoadingPanel(false));
      })
      .catch((err) => {
        dispatch(setLoadingPanel(false));
        if (err?.response?.data) {
          toast(err.response?.status + " " + err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: {
              maxWidth: "90vw",
              width: "auto",
              margin: "5px  auto",
              padding: "5px 5px",
              fontSize: "14px",
            },
            closeButton: (
              <div className="flex justify-end">
                <button className="text-gray-500 hover:text-gray-800 focus:outline">
                  <CloseIcon className="w-7 h-7" />
                </button>
              </div>
            ),
          });
        } else {
          toast(err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: {
              maxWidth: "90vw",
              width: "auto",
              margin: "5px  auto",
              padding: "5px 5px",
              fontSize: "14px",
            },
            closeButton: (
              <div className="flex justify-end">
                <button className="text-gray-500 hover:text-gray-800 focus:outline">
                  <CloseIcon className="w-7 h-7" />
                </button>
              </div>
            ),
          });
        }
        if (err.response?.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      });
  };

  const handleToggleSelectAll = () => {
    setSelectAll((prev) => {
      if (!prev) setColumns([...states]);
      else {
        setColumns([]);
        setRenderPrice([]);
      }
      return !prev;
    });
  };
  const addEditPrice = (row) => {};
  const addPrice = () => {
    if (selectedProduct?.prices?.length > 0) {
      columns.map((c) => {
        const data = selectedProduct.prices.find(
          (p) => p.group.name === c.name
        );
        if (data) {
          c.priceId = data.id;
        }
      });
    }

    columns.map((col) => {
      col.startDate = pricePayload.startDate;
      col.endDate = pricePayload.endDate;
      col.mop = pricePayload.mop;
      col.dp = pricePayload.dp;
      col.mrp = pricePayload.mrp;
      priceArray.push(col);
    });
    setRenderPrice(priceArray);
  };

  useEffect(() => {
    addPrice();
    return () => {};
  }, [columns]);

  const savePrice = async () => {
    if (!Array.isArray(renderPrice) || renderPrice.length === 0) {
      toast("No prices to update", {
        type: "info",
        position: toast.POSITION.TOP_CENTER,
        autoClose: 1000,
        hideProgressBar: true,
      });
      return;
    }

    setIsSavingPrice(true);
    dispatch(setLoadingPanel(true));

    const showToast = (message, type) => {
      toast(message, {
        type,
        position: toast.POSITION.TOP_CENTER,
        autoClose: 100,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: {
          maxWidth: "90vw",
          width: "auto",
          margin: "5px auto",
          padding: "5px 5px",
          fontSize: "14px",
        },
        closeButton: (
          <div className="flex justify-end">
            <button className="text-gray-500 hover:text-gray-800 focus:outline">
              <CloseIcon className="w-7 h-7" />
            </button>
          </div>
        ),
      });
    };

    const processPrice = async (price, delay, index) => {
      try {
        await new Promise((resolve) => setTimeout(resolve, delay * index));
        if (price.id) {
          await ProductsApi.EditPrice(selectedProduct.id, price.id, price);
          showToast("New Price Updated", "success");
        } else {
          await ProductsApi.AddPrice(selectedProduct.id, price);
          showToast("Price Created", "success");
        }
      } catch (err) {
        showToast(err?.response?.data?.message || "An error occurred", "error");
      }
    };

    const payloadArray = renderPrice.map((price) => ({
      id: price.priceId,
      startDate: price.startDate,
      endDate: price.endDate,
      mop: price.mop,
      dp: price.dp,
      mrp: price.mrp,
      state: {
        id: price.id,
        name: price.name,
      },
      isActive: price.isActive,
    }));

    try {
      await Promise.all(
        payloadArray.map((price, i) => processPrice(price, 500, i))
      );
    } finally {
      setIsSavingPrice(false);
      dispatch(setLoadingPanel(false));
      setColumns([]);
      setRenderPrice([]);
      setIsPriceOpen(false);
    }
  };

  const saveEditedPrice = () => {
    ProductsApi.UpdateCurrentPrice(
      selectedProduct.id,
      singleEditPayload,
      selectedPrice.id
    )
      .then((res) => {
        toast(res.message, {
          type: "success",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            maxWidth: "90vw",
            width: "auto",
            margin: "5px  auto",
            padding: "5px 5px",
            fontSize: "14px",
          },
          closeButton: (
            <div className="flex justify-end">
              <button className="text-gray-500 hover:text-gray-800 focus:outline">
                <CloseIcon className="w-7 h-7" />
              </button>
            </div>
          ),
        });
        setEditIndividualPrice(false);
        getProducts(null, currentPage - 1, fetchSize);
      })
      .catch((err) => {
        toast(err?.response?.data?.message, {
          type: "error",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            maxWidth: "90vw",
            width: "auto",
            margin: "5px  auto",
            padding: "5px 5px",
            fontSize: "14px",
          },
          closeButton: (
            <div className="flex justify-end">
              <button className="text-gray-500 hover:text-gray-800 focus:outline">
                <CloseIcon className="w-7 h-7" />
              </button>
            </div>
          ),
        });
      });
  };
  const handlePageChange = (e, page) => {
    setCurrentPage(page);
    return currentPage;
  };

  const options = ["Edit Product" /*"Variant +"*/, , "Price +", "Color +"];
  const [showPrice, setShowPrice] = React.useState(false);
  const [showColor, setShowColor] = React.useState(false);
  const [showVariant, setShowVariant] = React.useState(false);
  // const edit = () => {
  //   onEditClick(row);
  // };
  // const variant = () => {
  //   onVariantClick(row);
  // };
  // const colour = () => {
  //   onColorClick(row);
  // };
  // const price = () => {
  //   onPriceClick(row);
  // };

  // const editPrice = (p) => {
  //   pricesEditClick(p, row);
  // };
  // const editColor = (c) => {
  //   colorsEditClick(c, row);
  // };
  // const editVariant = (v) => {
  //   variantsEditClick(v, row);
  // };

  const isMobile = useMediaQuery("(max-width:768px)");
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.loadingReducer.isLoading);

  const [openEditPop, setOpenEditPop] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  // const handlePriceClick = () => {
  //   setShowPrice(true);
  // };
  // const handleColorClick = () => {
  //   setShowColor(true);
  // };
  // const handleVariantClick = () => {
  //   setShowVariant(true);
  // };

  // const handleMenuItemClick = (event, index) => {
  //   setSelectedIndex(index);

  //   setOpen(false);
  // };

  // const handleToggle = () => {
  //   setOpen((prevOpen) => !prevOpen);
  // };

  // const handleCloseEditPop = (event) => {
  //   if (anchorRef.current && anchorRef.current.contains(event.target)) {
  //     return;
  //   }
  //   setOpen(false);
  // };
  // const [anchorElPrices, setAnchorElPrices] = React.useState(null);
  // const [idPrices, setIdPrices] = React.useState(null);
  // const [anchorElColors, setAnchorElColors] = React.useState(null);
  // const [idColors, setIdColors] = React.useState(null);
  // const [anchorElVariants, setAnchorElVariants] = React.useState(null);
  // const [idVariants, setIdVariants] = React.useState(null);

  // const handleClickShowPrices = (event) => {
  //   setAnchorElPrices(event.currentTarget);
  //   setIdPrices("prices-popover");
  // };

  // const handleClickShowColors = (event) => {
  //   setAnchorElColors(event.currentTarget);
  //   setIdColors("colors-popover");
  // };

  // const handleClickShowVariants = (event) => {
  //   setAnchorElVariants(event.currentTarget);
  //   setIdVariants("variants-popover");
  // };

  // const handleCloseShowPrices = () => {
  //   setAnchorElPrices(null);
  // };

  // const handleCloseShowColors = () => {
  //   setAnchorElColors(null);
  // };

  // const handleCloseShowVariants = () => {
  //   setAnchorElVariants(null);
  // };

  const PlusIcon = createSvgIcon(
    // credit: plus icon from https://heroicons.com/
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 4.5v15m7.5-7.5h-15"
      />
    </svg>,
    "Plus"
  );
  return (
    <>
      <CircularIndeterminateModal
        open={
          isLoading &&
          (!brands.length || !categoryList.length || !states.length)
        }
      />
      <PriceTable
        editIndividualPrice={editIndividualPrice}
        product={selectedProduct}
        setSelectedProduct={setSelectedProduct}
        setSelectedPrice={setSelectedPrice}
        setSingleEditPayload={setSingleEditPayload}
        setEditIndividualPrice={setEditIndividualPrice}
        isPriceTableOpen={isPriceTableOpen}
        setIsPriceTableOpen={setIsPriceTableOpen}
      />
      <div
        className={`
        relative flex flex-col  items-center
        min-w-0 break-words w-full mb-6 shadow-lg rounded
        ${color === "light" ? "bg-white" : "bg-lightBlue-900 text-white"}
      `}
      >
        <div className="flex flex-col w-full lg:flex-row">
          <div className="w-full lg:w-[70%] p-4 md:p-8">
            <Box className="w-full">
              <FormControl fullWidth sx={filterFormControlSx}>
                <InputLabel
                  id="brand-select-label"
                  className="text-sm md:text-base"
                >
                  Brand
                </InputLabel>
                <Select
                  labelId="brand-select-label"
                  id="brand-select"
                  value={selectedBrand || ""}
                  label={
                    <span className="text-sm md:text-base font-medium">
                      Brand
                    </span>
                  }
                  sx={{
                    ...filterSelectSx,
                    fontSize: {
                      xs: "12px",
                      sm: "13x",
                      md: "13px",
                      lg: "16px",
                    },
                  }}
                  onChange={handleChange}
                >
                  {brands.map((brand, index) => (
                    <MenuItem
                      key={index}
                      value={brand}
                      // className="text-sm md:text-base"
                      sx={{
                        fontSize: {
                          xs: "12px",
                          sm: "13x",
                          md: "13px",
                          lg: "16px",
                        },
                      }}
                    >
                      {brand.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </div>

          <div className="w-full lg:w-[30%] md:p-8 p-4 flex items-center">
            <Button
              onClick={openAddUpdateProduct}
              fullWidth
              variant="contained"
              color="primary"
              sx={{
                height: "40px",
                fontSize: {
                  xs: "12px",
                  sm: "13px",
                  md: "13px",
                  lg: "16px",
                },
              }}
              className="whitespace-nowrap"
              startIcon={<PlusIcon className="h-4 w-4 md:h-5 md:w-5" />}
            >
              Add Product
            </Button>
          </div>
        </div>

        <Grid
          item
          xs={12}
          md={4}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: { md: "flex-start", xs: "center" },
            width: "100%",
          }}
        >
          <FormControl
            sx={{
              mb: 2,
              minWidth: "100%",
              my: "auto",
            }}
          >
            <FormLabel
              id="demo-row-radio-buttons-group-label"
              className="lg:text-start text-center"
            >
              Active
            </FormLabel>
            <RadioGroup
              value={isActive}
              row
              onChange={(e) => setIsActive(e.target.value)}
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="isActive"
              sx={{
                display: "flex",
                flexDirection: "row",
              }}
              className="text-xs flex lg:justify-start justify-center sm:text-sm md:text-base lg:text-lg font-medium"
            >
              <FormControlLabel
                value={true}
                control={
                  <Radio
                    sx={{
                      padding: "8px",
                      "& .MuiSvgIcon-root": {
                        fontSize: {
                          xs: "18px",
                          md: "22px",
                        },
                      },
                    }}
                  />
                }
                label="True"
              />
              <FormControlLabel
                value={false}
                control={
                  <Radio
                    sx={{
                      padding: "8px",
                      "& .MuiSvgIcon-root": {
                        fontSize: {
                          xs: "18px",
                          md: "22px",
                        },
                      },
                    }}
                  />
                }
                label="False"
              />
            </RadioGroup>
          </FormControl>
          <div className="w-full  md:p-8 p-4 flex items-center">
            <Button
              onClick={() => {
                setIsActive(null);
              }}
              fullWidth
              variant="contained"
              size="medium"
              color="secondary"
              className="whitespace-nowrap"
              sx={{
                height: { xs: "40px", md: "52px" },
                fontSize: {
                  xs: "12px",
                  sm: "13px",
                  md: "13px",
                  lg: "16px",
                },
              }}
            >
              Reset All{" "}
            </Button>
          </div>
        </Grid>
      </div>
    
      <div
        className={
          "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
          (color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
        }
      >
        <div className="block w-full overflow-x-auto md:p-8 p-4">
          <div className="mb-3 pt-0">
            <input
              value={searchTerm}
              onChange={(e) => {
                const value = e.target.value;
                setSearchTerm(value);
                setCurrentPage(1);
                setIsSearchLoading(true);
                if (searchDebounceRef.current) {
                  clearTimeout(searchDebounceRef.current);
                }
                searchDebounceRef.current = setTimeout(() => {
                  setDebouncedSearchTerm(value);
                }, 300);
              }}
              type="text"
              placeholder="Search Model by name"
              className="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white  font-medium rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
            />
          </div>
        </div>
      </div>

      <div
        className={
          "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
          (color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
        }
      >
        <div className="block w-full overflow-x-auto py-3 px-4 lg:p-8">
          <div className="mb-4 lg:mb-6">
            <Stack
              direction={{ xs: "column", md: "row" }}
              spacing={{ xs: 1, lg: 3 }}
              divider={<Divider orientation="vertical" flexItem />}
              className="items-center lg:items-start"
            >
              <Stack
                spacing={{ xs: 1, lg: 3 }}
                direction={{ xs: "column", md: "row" }}
                divider={<Divider orientation="vertical" flexItem />}
                className="items-center lg:items-start"
              >
                <FormControl>
                  <InputLabel
                    id="size-select-label"
                    className="text-sm lg:text-base"
                  >
                    Size
                  </InputLabel>
                  <Select
                    labelId="size-select-label"
                    id="size-select"
                    size="small"
                    value={fetchSize}
                    label={
                      <span className="text-sm lg:text-base font-medium">
                        Size
                      </span>
                    }
                    onChange={(e) => {
                      setCurrentPage(1);
                      setFetchSize(e.target.value);
                    }}
                    sx={{
                      fontSize: {
                        xs: "12px",
                        sm: "13px",
                        md: "13px",
                        lg: "16px",
                      },
                    }}
                  >
                    {[10, 25, 50, 100].map((size) => (
                      <MenuItem
                        key={size}
                        value={size}
                        sx={{
                          height: { xs: "40px", md: "52px" },
                          fontSize: {
                            xs: "12px",
                            sm: "13px",
                            md: "13px",
                            lg: "16px",
                          },
                        }}
                      >
                        {size}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <div className="flex items-center justify-center lg:justify-start my-auto">
                  <span className="text-xs sm:text-sm my-auto lg:text-base font-medium">
                    Total Products: {totalElements}
                  </span>
                </div>
              </Stack>

              <div className="flex justify-center w-full lg:w-auto">
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  color="primary"
                  onChange={handlePageChange}
                  size={isMobile ? "small" : "medium"}
                />
              </div>
            </Stack>
          </div>
          <div className="overflow-x-auto ">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-100">
                <tr className="divide-x divide-gray-200">
                  <TableHeader heading="" />
                  <TableHeader heading="Image" />
                  <TableHeader heading="Name" />
                  <TableHeader heading="Prices" />
                  <TableHeader heading="Active" />
                  <TableHeader heading="Video" />
                  <TableHeader heading="Position" />
                  <TableHeader heading="Category" />
                  <TableHeader heading="Sub Category" />
                  <TableHeader heading="" />
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                {isSearchLoading ? (
                  <tr>
                    <td colSpan={10} className="py-12 text-center">
                      <CircularProgress size={32} />
                      <p className="mt-2 text-sm text-gray-500">Searching...</p>
                    </td>
                  </tr>
                ) : products.length === 0 ? (
                  <tr>
                    <td colSpan={10} className="py-12 text-center text-sm text-gray-400">
                      No products found.
                    </td>
                  </tr>
                ) : null}
                {!isSearchLoading && products.map((p, index) => (
                  <tr
                    key={index}
                    className="divide-x divide-gray-200 hover:bg-slate-100"
                  >
                    <TableElement
                      value={
                        currentPage && fetchSize
                          ? (currentPage - 1) * fetchSize + (index + 1)
                          : index + 1
                      }
                    />
                    <TableElement
                      value={
                        p.image === null || " " ? (
                          <i className="fa-regular fa-image fa-xl" />
                        ) : (
                          <img
                            alt="product"
                            src={p.image}
                            className="h-12 w-12 bg-white border-4"
                          />
                        )
                      }
                      type="element"
                    />
                    <TableElement
                      value={
                        <div className="space-y-1">
                          <div>{p.primaryName}</div>
                          <div>{p.secondaryName}</div>
                        </div>
                      }
                      type="element"
                    />
                    <TableElement
                      value={
                        <Button
                          variant="text"
                          size="small"
                          onClick={() => {
                            setSelectedProduct(p);
                            setOpenPricesTable(true);
                            setIsPriceTableOpen(true);
                          }}
                          className="text-xs lg:text-sm"
                        >
                          {`Show - ${p?.prices?.length}`}
                        </Button>
                      }
                      type="element"
                    />
                    <TableElement value={p.isActive} type="boolean" />
                    <TableElement
                      value={
                        p.video && p.video !== " " ? (
                          <a href={p.video} target="_blank" rel="noreferrer">
                            <i className="fa-xl fa-solid fa-circle-play" />
                          </a>
                        ) : null
                      }
                      type="element"
                    />
                    <TableElement value={p.position} />
                    <TableElement value={p.category?.name} />
                    <TableElement value={p.subCategory?.name} />
                    <TableElement
                      value={
                        <div className="flex flex-col space-y-2">
                          <button
                            className="text-blue-300 hover:text-blue-700 text-xs lg:text-sm"
                            onClick={() => editProduct(p)}
                          >
                            EDIT PRODUCT
                          </button>
                          <button
                            className="text-blue-300 hover:text-blue-700 text-xs lg:text-sm"
                            onClick={() => {
                              setSelectedProduct(p);
                              setIsPriceOpen(true);
                            }}
                          >
                            PRICE +
                          </button>
                          <button
                            className="text-blue-300 hover:text-blue-700 text-xs lg:text-sm"
                            onClick={() => addEditColor(p)}
                          >
                            COLOR +
                          </button>
                        </div>
                      }
                      type="element"
                    />
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* POPOVER EDIT PRODUCTS  */}

      {/* Products Add / Update Dialog */}
      <div>
        <Dialog
          fullScreen
          open={open}
          onClose={() => setOpen(false)}
          TransitionComponent={Transition}
        >
          <AppBar sx={{ position: "relative" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={() => setOpen(false)}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                {isEdit
                  ? "Edit Product - " + productAddPayload.primaryName
                  : "Add Product"}
              </Typography>
            </Toolbar>
          </AppBar>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <TextField
                  id="standard-requried"
                  required
                  sx={{ m: 2 }}
                  label="Primary Name"
                  variant="standard"
                  value={productAddPayload.primaryName}
                  onChange={(e) => {
                    setProductAddPayload({
                      ...productAddPayload,
                      primaryName: e.target.value,
                    });
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  id="standard-requried"
                  sx={{ m: 2 }}
                  label="Secondary Name"
                  variant="standard"
                  value={productAddPayload.secondaryName}
                  onChange={(e) => {
                    setProductAddPayload({
                      ...productAddPayload,
                      secondaryName: e.target.value,
                    });
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  id="standard-requried"
                  sx={{ m: 2 }}
                  label="Description"
                  variant="standard"
                  value={productAddPayload.description}
                  onChange={(e) => {
                    setProductAddPayload({
                      ...productAddPayload,
                      description: e.target.value,
                    });
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl
                  variant="standard"
                  fullWidth
                  sx={{ m: 2, minWidth: "100%" }}
                >
                  <InputLabel id="demo-simple-select-label">Brand</InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    variant="standard"
                    value={productAddPayload.brandId}
                    label="Brand"
                    onChange={(e) => {
                      let brand = brands.filter((b) => b.id === e.target.value);
                      setProductAddPayload({
                        ...productAddPayload,
                        brandId: brand[0]?.id,
                        brand: e.target.value,
                        category: brand[0]?.category,
                        categoryId: brand[0]?.category.id,
                      });
                    }}
                  >
                    {brands.map((b, i) => (
                      <MenuItem key={i} value={b.id}>
                        {b.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl
                  variant="standard"
                  fullWidth
                  sx={{ m: 2, minWidth: "100%" }}
                >
                  <InputLabel id="demo-simple-select-label">
                    Brand Series
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    variant="standard"
                    value={productAddPayload.brandSeriesId}
                    label="Brand"
                    onChange={(e) => {
                      setProductAddPayload({
                        ...productAddPayload,
                        brandSeriesId: e.target.value,
                      });
                    }}
                  >
                    {brands
                      .filter((b) => b.id === productAddPayload.brandId)[0]
                      ?.series?.map((bs, i) => {
                        if (bs.name) {
                          return (
                            <MenuItem key={i} value={bs.id}>
                              {bs.name}
                            </MenuItem>
                          );
                        } else return null;
                      })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  id="standard-requried"
                  sx={{ m: 2 }}
                  label="Product Code"
                  variant="standard"
                  value={productAddPayload.productCode}
                  onChange={(e) => {
                    setProductAddPayload({
                      ...productAddPayload,
                      productCode: e.target.value,
                    });
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl
                  variant="standard"
                  fullWidth
                  sx={{ m: 2, minWidth: "100%" }}
                >
                  <InputLabel id="demo-simple-select-label">
                    {productAddPayload.brand ? "" : "Category"}
                  </InputLabel>
                  <Select
                    disabled
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    variant="standard"
                    value={productAddPayload.categoryId}
                    label="Category"
                  >
                    {categoryList.map((c, i) => (
                      <MenuItem key={i} value={c.id}>
                        {c.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl
                  variant="standard"
                  fullWidth
                  sx={{ m: 2, minWidth: "100%" }}
                >
                  <InputLabel id="demo-simple-select-label">
                    Sub Category
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    variant="standard"
                    value={productAddPayload.subCategoryId}
                    label=" Sub Category"
                    onChange={(e) => {
                      setProductAddPayload({
                        ...productAddPayload,
                        subCategoryId: e.target.value,
                      });
                    }}
                  >
                    {categoryList
                      .filter((c) => c.id === productAddPayload.categoryId)[0]
                      ?.subcategories?.map((c, i) => {
                        if (c.name) {
                          return (
                            <MenuItem key={i} value={c.id}>
                              {c.name}
                            </MenuItem>
                          );
                        } else return null;
                      })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}></Grid>
              <Grid item xs={12} md={4}>
                <FormControl variant="standard" sx={{ m: 2, minWidth: "100%" }}>
                  <FormLabel id="demo-row-radio-buttons-group-label">
                    Active
                  </FormLabel>
                  <RadioGroup
                    value={productAddPayload.isActive}
                    row
                    onChange={(e) => {
                      setProductAddPayload({
                        ...productAddPayload,
                        isActive: e.target.value,
                      });
                    }}
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="isActive"
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label="True"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label="False"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  id="standard-requried"
                  sx={{ m: 2 }}
                  label="Image URL"
                  variant="standard"
                  value={productAddPayload.image}
                  onChange={(e) => {
                    setProductAddPayload({
                      ...productAddPayload,
                      image: e.target.value,
                    });
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  id="standard-requried"
                  sx={{ m: 2 }}
                  label="Video URL"
                  variant="standard"
                  value={productAddPayload.video}
                  onChange={(e) => {
                    setProductAddPayload({
                      ...productAddPayload,
                      video: e.target.value,
                    });
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  id="standard-requried"
                  sx={{ m: 2 }}
                  label="HSN Code"
                  variant="standard"
                  value={productAddPayload.hsnCode}
                  onChange={(e) => {
                    setProductAddPayload({
                      ...productAddPayload,
                      hsnCode: e.target.value,
                    });
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  id="standard-requried"
                  sx={{ m: 2 }}
                  label="TAC Code"
                  variant="standard"
                  value={
                    productAddPayload?.tacCode?.length > 0
                      ? productAddPayload?.tacCode[0]
                      : undefined
                  }
                  onChange={(e) => {
                    setProductAddPayload({
                      ...productAddPayload,
                      tacCode: [].push(e.target.value),
                    });
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  type="number"
                  id="standard-requried"
                  sx={{ m: 2 }}
                  label="Position"
                  variant="standard"
                  value={productAddPayload.position}
                  onChange={(e) => {
                    setProductAddPayload({
                      ...productAddPayload,
                      position: e.target.value,
                    });
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <div className="  flex flex-col h-full items-center justify-center font-medium">
                  Add Specifications Here :-
                  <TextField
                    InputLabelProps={{
                      shrink: specification?.key?.length > 0,
                    }}
                    disabled={specification?.key in basicSpecs}
                    id="standard-requried"
                    sx={{ m: 2 }}
                    label={"Name"}
                    value={specification?.key}
                    variant="standard"
                    onChange={(e) => {
                      setSpecification({
                        ...specification,
                        key: e.target.value,
                      });
                    }}
                  />
                  <Button
                    sx={{ m: 2 }}
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                      if (specification.key) {
                        setProductAddPayload({
                          ...productAddPayload,
                          specifications: {
                            ...productAddPayload.specifications,
                            ["" + specification.key.trim().replace(" ", "_")]:
                              specification.value,
                          },
                        });
                        setSpecification({ key: "", value: "" });
                      }
                    }}
                  >
                    Add
                  </Button>
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                {" "}
                {Object.entries(
                  productAddPayload.specifications
                    ? productAddPayload.specifications
                    : {}
                ).map(([key, value], i) => (
                  <div key={key} className=" flex justify-between m-1">
                    <TextField
                      InputLabelProps={{
                        shrink: key?.length > 0,
                      }}
                      id="standard-requried"
                      sx={{ m: 1 }}
                      disabled
                      label={key ? "." : "Specification Name"}
                      variant="standard"
                      value={key.replace("_", " ")}
                      fullWidth
                    />
                    <TextField
                      id="standard-requried"
                      sx={{ m: 1 }}
                      label="Value"
                      variant="standard"
                      value={value}
                      onChange={(e) => {
                        setProductAddPayload({
                          ...productAddPayload,
                          specifications: {
                            ...productAddPayload.specifications,
                            [key]: e.target.value,
                          },
                        });
                      }}
                      fullWidth
                    />

                    {/* <div className="flex min-w-[80%] ">
                      <span className="font-bold">{`${key.replace(
                        "_",
                        " "
                      )} :-   `}</span>{" "}
                      <span className="mx-1 font-medium">{value}</span>
                    </div> */}

                    <DeleteIcon
                      onClick={() => {
                        if (!(key in basicSpecs)) {
                          setSpecification({
                            key: "",
                            value: "",
                          });
                          const spec = productAddPayload.specifications;
                          delete spec[key];
                          setProductAddPayload({
                            ...productAddPayload,
                            specifications: spec,
                          });
                        }
                      }}
                      sx={{
                        m: 2,
                        fontSize: "2rem",
                        cursor: key in basicSpecs ? "not-allowed" : "pointer",
                        color: key in basicSpecs ? "grey" : "red",
                      }}
                    />
                  </div>
                ))}
              </Grid>
              <Grid item xs={12} md={4}></Grid>

              <Grid item xs={12} md={4}></Grid>
              <Grid item xs={12} md={4}></Grid>
              <Grid item xs={12} md={4}>
                <div className="text-center">
                  <span>
                    {isEdit ? (
                      <Button
                        variant="contained"
                        size="medium"
                        color="primary"
                        sx={{ m: 2 }}
                        onClick={edit}
                      >
                        Save Changes
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        size="medium"
                        color="primary"
                        sx={{ m: 2 }}
                        onClick={save}
                      >
                        Create Product
                      </Button>
                    )}
                  </span>
                </div>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
      </div>

      {/* variant */}
      <div>
        <Dialog
          fullWidth
          maxWidth={"sm"}
          open={isVariantOpen}
          onClose={() => setIsVariantOpen(false)}
          TransitionComponent={Transition}
        >
          <AppBar sx={{ position: "relative" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={() => setIsVariantOpen(false)}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                Add / Edit Variant
              </Typography>
            </Toolbar>
          </AppBar>
          <List>
            <ListItem className="mt-4">
              <div className="block w-full overflow-x-auto">
                <TextField
                  onChange={(e) =>
                    setVariantPayload({
                      ...variantPayload,
                      variantType: e.target.value,
                    })
                  }
                  value={variantPayload.variantType}
                  fullWidth
                  id="outlined-basic"
                  label="Type"
                  variant="outlined"
                />
              </div>
            </ListItem>
            <Divider />
            <ListItem className="mt-4">
              <div className="block w-full overflow-x-auto">
                <TextField
                  onChange={(e) =>
                    setVariantPayload({
                      ...variantPayload,
                      value: e.target.value,
                    })
                  }
                  value={variantPayload.value}
                  fullWidth
                  id="outlined-basic"
                  label="Value"
                  variant="outlined"
                />
              </div>
            </ListItem>
          </List>
          <DialogActions>
            {isEditingVariant ? (
              <Button onClick={editVariant}>Save Changes</Button>
            ) : (
              <Button onClick={saveVariant}>Save</Button>
            )}
          </DialogActions>
        </Dialog>
      </div>

      {/* color */}
      <div>
        <Dialog
          fullWidth
          maxWidth={"sm"}
          open={isColorOpen}
          onClose={() => setIsColorOpen(false)}
          TransitionComponent={Transition}
        >
          <AppBar sx={{ position: "relative" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={() => setIsColorOpen(false)}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                Add / Edit Color
              </Typography>
            </Toolbar>
          </AppBar>
          <List>
            <ListItem className="mt-4">
              <div className="block w-full overflow-x-auto">
                <TextField
                  onChange={(e) =>
                    setColorPayload({
                      ...colorPayload,
                      name: e.target.value,
                    })
                  }
                  value={colorPayload.name}
                  fullWidth
                  id="outlined-basic"
                  label="Name"
                  variant="outlined"
                />
              </div>
            </ListItem>
            <Divider />
            <ListItem className="mt-4">
              <div className="block w-full overflow-x-auto">
                <TextField
                  onChange={(e) =>
                    setColorPayload({
                      ...colorPayload,
                      hexCode: e.target.value,
                    })
                  }
                  value={colorPayload.hexCode}
                  fullWidth
                  id="outlined-basic"
                  label="Hex code"
                  variant="outlined"
                />
              </div>
            </ListItem>
          </List>
          <DialogActions>
            {isEditingColor ? (
              <Button onClick={editColor}>Save Changes</Button>
            ) : (
              <Button onClick={saveColor}>Save</Button>
            )}
          </DialogActions>
        </Dialog>
      </div>

      {/* price */}
      <div>
        <Dialog
          fullScreen
          open={isPriceOpen}
          onClose={() => setIsPriceOpen(false)}
          TransitionComponent={Transition}
        >
          <AppBar sx={{ position: "relative" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={() => setIsPriceOpen(false)}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                Add Price -
                {` ${selectedProduct?.primaryName} ${selectedProduct?.secondaryName}`}
              </Typography>
              <Button
                autoFocus
                color="inherit"
                onClick={savePrice}
                disabled={isSavingPrice}
              >
                {isSavingPrice ? "Saving..." : "Save"}
              </Button>
            </Toolbar>
          </AppBar>
          <DialogContent className="relative">
            {isSavingPrice && (
              <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <CircularProgress />
              </div>
            )}
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <div className="flex flex-col md:flex-row justify-evenly">
                  <TextField
                    id="standard-requried"
                    required
                    type="number"
                    sx={{ m: 2 }}
                    label="DP"
                    variant="standard"
                    value={pricePayload.dp}
                    onChange={(e) => {
                      setPricePayload({
                        ...pricePayload,
                        dp: e.target.value,
                      });
                    }}
                  />
                  <TextField
                    id="standard-requried"
                    type="number"
                    required
                    sx={{ m: 2 }}
                    label="MOP"
                    variant="standard"
                    value={pricePayload.mop}
                    onChange={(e) => {
                      setPricePayload({
                        ...pricePayload,
                        mop: e.target.value,
                      });
                    }}
                  />
                  <TextField
                    id="standard-requried"
                    required
                    type="number"
                    sx={{ m: 2 }}
                    label="MRP"
                    variant="standard"
                    value={pricePayload.mrp}
                    onChange={(e) => {
                      setPricePayload({
                        ...pricePayload,
                        mrp: e.target.value,
                      });
                    }}
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className="flex flex-col md:flex-row justify-evenly">
                  <TextField
                    id="standard-requried"
                    required
                    type="date"
                    sx={{ m: 2 }}
                    label="Start Date"
                    variant="standard"
                    value={pricePayload.startDate}
                    onChange={(e) => {
                      setPricePayload({
                        ...pricePayload,
                        startDate: e.target.value,
                      });
                    }}
                  />
                  <TextField
                    id="standard-requried"
                    required
                    type="date"
                    sx={{ m: 2 }}
                    label="End Date"
                    variant="standard"
                    value={pricePayload.endDate}
                    onChange={(e) => {
                      setPricePayload({
                        ...pricePayload,
                        endDate: e.target.value,
                      });
                    }}
                  />
                  <TextField
                    id="standard-requried"
                    sx={{ m: 2 }}
                    label="Remark"
                    variant="standard"
                    value={pricePayload.remark}
                    onChange={(e) => {
                      setPricePayload({
                        ...pricePayload,
                        remark: e.target.value,
                      });
                    }}
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl variant="standard" sx={{ m: 2, minWidth: "100%" }}>
                  <FormLabel id="demo-row-radio-buttons-group-label">
                    Active
                  </FormLabel>
                  <RadioGroup
                    row
                    value={pricePayload.isActive}
                    onChange={(e) =>
                      setPricePayload({
                        ...pricePayload,
                        isActive: e.target.value,
                      })
                    }
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="isActive"
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label="True"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label="False"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12}>
                <div className="block w-full overflow-x-auto">
                  {states ? (
                    <Autocomplete
                      variant="standard"
                      sx={{ m: 2 }}
                      multiple
                      disabled={
                        !pricePayload.dp ||
                        !pricePayload.mrp ||
                        !pricePayload.mop
                      }
                      options={states}
                      filterSelectedOptions
                      freeSolo={false}
                      getOptionLabel={(option) =>
                        typeof option === "string" ? option : option.name
                      }
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      value={columns}
                      onChange={(_e, value, reason) => {
                        if (reason === "clear" || reason === "removeOption")
                          setSelectAll(false);
                        if (
                          reason === "selectOption" &&
                          value.length === states.length
                        )
                          setSelectAll(true);
                        setColumns(value);
                      }}
                      renderInput={(params) => (
                        <TextField
                          variant="standard"
                          {...params}
                          label={"Select States"}
                        />
                      )}
                      PaperComponent={(paperProps) => {
                        const { children, ...restPaperProps } = paperProps;
                        return (
                          <Paper {...restPaperProps}>
                            <Box
                              onMouseDown={(e) => e.preventDefault()} // prevent blur
                              pl={1.5}
                              py={0.5}
                            >
                              <FormControlLabel
                                onClick={(e) => {
                                  e.preventDefault(); // prevent blur
                                  handleToggleSelectAll();
                                }}
                                label="Select all"
                                control={
                                  <Checkbox
                                    id="select-all-checkbox"
                                    checked={selectAll}
                                  />
                                }
                              />
                            </Box>
                            <Divider />
                            {children}
                          </Paper>
                        );
                      }}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              </Grid>
            </Grid>
            <Divider sx={{ m: 2 }} />
            <AddPriceTable
              setRenderPrice={setRenderPrice}
              renderPrice={renderPrice}
            />
          </DialogContent>
        </Dialog>
      </div>

      {/* Individual price */}
      <div>
        <Dialog
          // fullScreen
          open={editIndividualPrice}
          // onClose={(e, r) => {
          //   if (r !== "backdropClick") {
          //     setEditIndividualPrice(false);
          //   }
          // }}
          // TransitionComponent={Transition}
        >
          <AppBar sx={{ position: "relative" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={() => setEditIndividualPrice(false)}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                Edit Price - {selectedProduct?.primaryName} -{" "}
                {selectedPrice?.group?.name}
              </Typography>
              <Button autoFocus color="inherit" onClick={saveEditedPrice}>
                Save
              </Button>
            </Toolbar>
          </AppBar>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <TextField
                  id="standard-requried"
                  required
                  type="number"
                  sx={{ m: 2 }}
                  label="DP"
                  variant="standard"
                  onChange={(e) =>
                    setSingleEditPayload({
                      ...singleEditPayload,
                      dp: e.target.value,
                    })
                  }
                  value={singleEditPayload.dp}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  id="standard-requried"
                  type="number"
                  required
                  sx={{ m: 2 }}
                  label="MOP"
                  variant="standard"
                  onChange={(e) =>
                    setSingleEditPayload({
                      ...singleEditPayload,
                      mop: e.target.value,
                    })
                  }
                  value={singleEditPayload.mop}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  id="standard-requried"
                  required
                  type="number"
                  sx={{ m: 2 }}
                  label="MRP"
                  variant="standard"
                  onChange={(e) =>
                    setSingleEditPayload({
                      ...singleEditPayload,
                      mrp: e.target.value,
                    })
                  }
                  value={singleEditPayload.mrp}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  id="standard-requried"
                  required
                  type="date"
                  sx={{ m: 2 }}
                  label="Start Date"
                  variant="standard"
                  onChange={(e) =>
                    setSingleEditPayload({
                      ...singleEditPayload,
                      startDate: e.target.value,
                    })
                  }
                  value={singleEditPayload.startDate}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  id="standard-requried"
                  required
                  type="date"
                  sx={{ m: 2 }}
                  label="End Date"
                  variant="standard"
                  onChange={(e) =>
                    setSingleEditPayload({
                      ...singleEditPayload,
                      endDate: e.target.value,
                    })
                  }
                  value={singleEditPayload.endDate}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  id="standard-requried"
                  sx={{ m: 2 }}
                  label="Remark"
                  variant="standard"
                  onChange={(e) =>
                    setSingleEditPayload({
                      ...singleEditPayload,
                      remark: e.target.value,
                    })
                  }
                  value={singleEditPayload.remark}
                />
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}

const PriceTable = ({
  product,
  setSelectedProduct,
  setSelectedPrice,
  setSingleEditPayload,
  editIndividualPrice,
  setEditIndividualPrice,
  isPriceTableOpen,
  setIsPriceTableOpen,
}) => {
  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
      padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
      padding: theme.spacing(1),
    },
  }));

  // console.log("P", product);

  const editPriceClicked = (price, product) => {
    setSelectedPrice(price);
    setSelectedProduct(product);
    setSingleEditPayload({
      dp: price.dp,
      mop: price.mop,
      mrp: price.mrp,
      startDate: price.startDate,
      endDate: price.endDate,
    });
    setEditIndividualPrice(true);
  };

  return product?.prices ? (
    <>
      <BootstrapDialog
        onClose={() => {
          if (!editIndividualPrice) {
            setSelectedProduct(null);
          }
          setIsPriceTableOpen(false);
        }}
        aria-labelledby="customized-dialog-title-prices"
        open={isPriceTableOpen}
        maxWidth="lg"
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title-prices">
          Price Details - {product.primaryName}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => {
            if (!editIndividualPrice) {
              setSelectedProduct(null);
            }
            setIsPriceTableOpen(false);
          }}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography gutterBottom>
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-100 sticky">
                <tr className="divide-x divide-gray-200 ">
                  <TableHeader heading="" />
                  <TableHeader heading="Group Name" />
                  <TableHeader heading="DP" />
                  <TableHeader heading="MOP" />
                  <TableHeader heading="MRP" />
                  <TableHeader heading="Date" />
                  <TableHeader heading="" />
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                {product.prices?.map((p, index) => {
                  return (
                    <tr
                      key={index}
                      className="divide-x divide-gray-200 hover:bg-slate-100"
                    >
                      <TableElement value={index + 1} />
                      <TableElement value={p.group?.name} />
                      <TableElement value={p.dp} />
                      <TableElement value={p.mop} />
                      <TableElement value={p.mrp} />
                      <TableElement
                        value={
                          <>
                            {p.startDate} - {p.endDate}
                          </>
                        }
                        type="element"
                      />
                      <TableElement
                        value={
                          <span
                            className="cursor-pointer text-sky-500 hover:text-sky-950 font-bold gr "
                            onClick={() => editPriceClicked(p, product)}
                          >
                            EDIT
                          </span>
                        }
                        type="element"
                      />
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Typography>
        </DialogContent>
      </BootstrapDialog>
    </>
  ) : (
    <></>
  );
};